import { render, staticRenderFns } from "./dialog-edit-company.vue?vue&type=template&id=6bef1468"
import script from "./dialog-edit-company.vue?vue&type=script&lang=js"
export * from "./dialog-edit-company.vue?vue&type=script&lang=js"
import style0 from "./dialog-edit-company.vue?vue&type=style&index=0&id=6bef1468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports